// Auth Service
import api from './api';

const authService = {
  signup: (userData) => api.post('/auth/signup', userData),
  login: (email, password) => api.post('/auth/login', { email, password }),
  logout: () => api.post('/auth/logout'),
  getCurrentUser: () => api.get('/auth/current-user'),
  updateProfile: (profileData) => api.put('/auth/profile', profileData),
  changePassword: (passwordData) => api.put('/auth/change-password', passwordData),
  requestPasswordReset: (email) => api.post('/auth/request-password-reset', { email }),
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
};

export default authService;
